import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import Button from 'packages/ui/Button';
import { Link } from 'react-router-dom';
import { CreditsUIProvider } from './CreditsContextProvider';

const CreditsList = React.lazy(() => import('./Credits'));

function Credits(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست کردیت‌ها</PageTitle>
        <Button as={Link} type="anchor" to="/credits/new">
          ساخت کردیت
        </Button>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <CreditsUIProvider>
          <CreditsList {...props} />
        </CreditsUIProvider>
      </Suspense>
    </Page>
  );
}

export default Credits;
